import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectFinalForms = state => state.finalForms;
const selectNamespace = (state, props) => props.namespace;

const selectFinalForm = createDeepEqualSelector(
    [selectFinalForms, selectNamespace],
    (finalFormsState, namespaceProp) =>
        finalFormsState && finalFormsState[namespaceProp]
);

const makeSelectFinalForm = namespace =>
    createDeepEqualSelector(
        selectFinalForms,
        finalFormsState => finalFormsState && finalFormsState[namespace]
    );

const makeSelectFinalFormValid = () =>
    createDeepEqualSelector(selectFinalForm, finalFormState =>
        finalFormState ? finalFormState.valid : true
    );

const makeSelectFinalFormPristine = () =>
    createDeepEqualSelector(selectFinalForm, finalFormState =>
        finalFormState ? finalFormState.pristine : false
    );

export {
    makeSelectFinalForm,
    makeSelectFinalFormValid,
    makeSelectFinalFormPristine
};
